import PersonalInformation from './PersonalInformation.component';

export default PersonalInformation;
